import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'

const Models = () => {
    const table = useRef(null)
    const urlGetData = '/v0/models'
    const localStorageOrderKey = 'tblModelsOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'code' },
        { data: 'name' }
    ]

    const tableHead = (
        <tr>
            <th>Code</th>
            <th>Name</th>
        </tr>
    )
    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/models/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/cadm/models/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Models</h2>

                            <Link type="button" className="btn btn-mr btn-primary" to="/cadm/models/new">New Model</Link>

                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Models</strong> may be added to the <strong>product tree</strong> of all new and existing <strong>projects</strong>.<br/>
                                The <strong>applicability</strong> of a configured item is defined in relation to a project's product tree.
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Models;
